(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    class CustomVideoControls {
    constructor(overlay) {
      this.overlay = overlay;
      this.deferredMedia = overlay.closest('deferred-media');
      if (!this.deferredMedia || !this.deferredMedia.dataset.customControls) return;

      this.playPauseBtn = overlay.querySelector('[data-play-pause-btn]');
      this.currentTimeEl = overlay.querySelector('[data-current-time]');
      this.durationEl = overlay.querySelector('[data-duration]');
      this.playIcon = overlay.querySelector('.custom-video-controls__icon--play');
      this.pauseIcon = overlay.querySelector('.custom-video-controls__icon--pause');
      
      this.durationSet = false;

      this.init();
    }

    init() {
      const checkVideo = setInterval(() => {
        this.video = this.deferredMedia.querySelector('video, iframe');
        if (this.video) {
          clearInterval(checkVideo);
          this.setupControls();
        }
      }, 100);
    }

    setupControls() {
      if (this.video.tagName === 'VIDEO') {
        this.setupNativeVideo();
      }

      if (this.playPauseBtn) {
        this.playPauseBtn.addEventListener('click', () => this.togglePlayPause());
      }
    }

    setupNativeVideo() {
      this.video.addEventListener('loadedmetadata', () => {
        if (this.video.duration && !isNaN(this.video.duration) && isFinite(this.video.duration)) {
          this.updateDuration(this.video.duration);
          this.durationSet = true;
        }
        
        // Check if video is autoplaying and set initial icon state
        if (!this.video.paused) {
          this.updatePlayPauseIcon(true);
        }
      });

      this.video.addEventListener('durationchange', () => {
        if (this.video.duration && !isNaN(this.video.duration) && isFinite(this.video.duration)) {
          this.updateDuration(this.video.duration);
          this.durationSet = true;
        }
      });

      this.video.addEventListener('loadeddata', () => {
        if (!this.durationSet && this.video.duration && !isNaN(this.video.duration) && isFinite(this.video.duration)) {
          this.updateDuration(this.video.duration);
          this.durationSet = true;
        }
      });

      this.video.addEventListener('timeupdate', () => {
        this.updateCurrentTime(this.video.currentTime);
        
        if (!this.durationSet && this.video.duration && !isNaN(this.video.duration) && isFinite(this.video.duration)) {
          this.updateDuration(this.video.duration);
          this.durationSet = true;
        }
      });

      this.video.addEventListener('play', () => this.updatePlayPauseIcon(true));
      this.video.addEventListener('pause', () => this.updatePlayPauseIcon(false));
      
      // Set initial state after a brief delay to ensure video state is ready
      setTimeout(() => {
        if (!this.video.paused) {
          this.updatePlayPauseIcon(true);
        }
        if (!this.durationSet && this.video.duration && !isNaN(this.video.duration) && isFinite(this.video.duration)) {
          this.updateDuration(this.video.duration);
          this.durationSet = true;
        }
      }, 200);
    }

    togglePlayPause() {
      if (this.video.tagName === 'VIDEO') {
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      }
    }

    updatePlayPauseIcon(isPlaying) {
      if (this.playIcon && this.pauseIcon) {
        if (isPlaying) {
          this.playIcon.classList.add('hidden');
          this.pauseIcon.classList.remove('hidden');
        } else {
          this.playIcon.classList.remove('hidden');
          this.pauseIcon.classList.add('hidden');
        }
      }
    }

    updateCurrentTime(seconds) {
      if (this.currentTimeEl) {
        this.currentTimeEl.textContent = this.formatTime(seconds);
      }
    }

    updateDuration(seconds) {
      if (this.durationEl) {
        this.durationEl.textContent = this.formatTime(seconds);
      }
    }

    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-custom-controls-overlay]').forEach(el => {
      new CustomVideoControls(el);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
